import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ClientFormModule } from '../client-form/client-form.module';
import { AppFormComponent } from './app-form.component';

@NgModule({
  declarations: [AppFormComponent],
  imports: [
    CommonModule,
    ClientFormModule
  ],
  providers: []
})
export class AppFormModule { }
